import * as Mutations from "@/store/mutations.type";

export default {
  [Mutations.SET_AWS_ERROR](state, error) {
    state.errors = error;
  },
  [Mutations.SET_AWS_PRODUCTS](state, products) {
    state.products = products;
  },
  [Mutations.SET_AWS_LOADING](state, loading) {
    state.loading = loading;
  },
  [Mutations.SET_AWS_SEARCH_MULTISELECT](state, search) {
    state.searchMultiselect = search;
  }
};
